import { trackEvent, trackEcommerce } from 'dibs-tracking';
import { pageTypes, isPageType } from 'dibs-buyer-layout/src/entries/index';

const { PAGE_TYPE } = pageTypes;
const LIST_NAME = 'recently viewed items carousel';

const trackInteraction = ({ action, label }) => {
    trackEvent({
        category: 'promo interaction',
        action,
        label,
        value: 0,
    });
};

export const trackInitialDisplay = ({ itemsReturned }) => {
    trackInteraction({
        action: 'recently viewed items displayed',
        label: itemsReturned,
    });
};

export const trackArrowClick = ({ direction }) => {
    trackInteraction({
        action: 'recently viewed items arrow clicked',
        label: direction,
    });
};

export const trackItemClick = () => {
    trackInteraction({
        action: 'recently viewed items item clicked',
        label: 'none',
    });
};

export const trackRecentItem = ({ type, item, position }) => {
    trackEcommerce({
        type,
        actionField: { list: LIST_NAME },
        products: [
            {
                brand: item.dealerPk,
                category: item.category,
                id: item.itemId,
                variant: isPageType(PAGE_TYPE.PDP) ? 'products' : 'homepage',
                name: item.itemTitle,
                list: LIST_NAME,
                dimension83: item.contemporaryTrackingString,
                position,
            },
        ],
    });
};



// WEBPACK FOOTER //
// ./assets/js/global/components/RecentlyViewedItems/recentlyViewedItemsTrackingHelpers.es.js